import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { router } from "./router";
import { initSentry, Sentry } from "./lib/sentry";
import { PostHogProvider } from "./lib/posthog";
import { installChunkReloadHandlers } from "./lib/chunk-reload";
import { installGlobalErrorHandlers, reportError } from "./lib/report-error";
import { AppErrorFallback } from "./components/AppErrorFallback";
import "./lib/i18n";
import "./lib/date";
import "./styles/global.css";

installChunkReloadHandlers();
initSentry();
installGlobalErrorHandlers();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

const ErrorBoundary = Sentry.ErrorBoundary;

createRoot(rootEl).render(
  <StrictMode>
    <PostHogProvider>
      <ErrorBoundary
        fallback={({ error, resetError }) => (
          <AppErrorFallback variant="fullPage" error={error} onReset={resetError} />
        )}
        onError={(error, componentStack) => reportError("root-boundary", error, { componentStack })}
      >
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </ErrorBoundary>
    </PostHogProvider>
  </StrictMode>,
);
